export default __webpack_public_path__ + "static/media/logo.67532c7d.jpg";